// Where memberships meet competitions and meets (MEMBERSHIPS_PLAN.md §4.9,
// D23, ME5, ME6, ME9; A3 on the API). The two reads the join screens use:
//
//   competitionMembershipRule(referenceType, referenceId) →
//     { eligibility: 'Anyone' | 'AnyMembership' | 'Types', neededLine, priceLine, summary, isPaid, currency,
//       holdsCurrent, pendingApplicationId, viewerFeeMinor, viewerPricedByMembershipTypeId, playersPerTeam,
//       qualifyingTypes: [{id, clubId, name, displayAs, priceSummary, lengthSummary, whoCanJoin, requiresApproval,
//       entryFeeMinor, joinVerb}] } | null (unknown target, or an API without the endpoint)
//     referenceType is the invite link's (1 ladder, 2 league cycle, 4 tournament, 5 meet, 6 americano cycle).
//     Works signed out (viewerFeeMinor is null then).
//
//   meetPassOffer(meetId, occurrenceId) →
//     { typeId, clubId, typeName, priceNowMinor, currency, sessionsLeft, sessionsTotal, perSessionMinor,
//       payAsYouGoMinor, termStart, termEnd, periodId, line, thenLine, headline } | null
//     (null = nothing to offer: no pass covers the meet with a cheaper row, not on sale, the viewer holds it,
//     the date is outside the block; the API answers 204).
import {useHttpRequest} from '~/composables/useHttpRequest';
import {endpoints} from '~/network/endpoints';

/** A3's endpoints are live: the invite gate, the member price line and the meet pass offer render. */
export const MEMBERSHIP_GATES_READY = true;

export function useMembershipGates() {
  const {httpRequest} = useHttpRequest();

  const competitionMembershipRule = async (referenceType, referenceId) => {
    if (!MEMBERSHIP_GATES_READY || !referenceId) return null;
    try {
      return await httpRequest(endpoints.memberships.competition.rule(referenceType, referenceId));
    } catch (e) {
      // 404 (unknown target) or an older API without the endpoint: no gate rather than a broken page.
      return null;
    }
  };

  const meetPassOffer = async (meetId, occurrenceId) => {
    if (!MEMBERSHIP_GATES_READY || !meetId) return null;
    try {
      const offer = await httpRequest(endpoints.memberships.competition.meetPassOffer(meetId, occurrenceId));
      return offer?.typeId ? offer : null;
    } catch (e) {
      // 204 has no body (the JSON parse throws): nothing to offer.
      return null;
    }
  };

  return {ready: MEMBERSHIP_GATES_READY, competitionMembershipRule, meetPassOffer};
}
